import { transformDateFormat } from '@shared/utils/dayjs';
import dayjs from 'dayjs';

export const notificationTitleDateFormat = (date: Date) => {
  const now = dayjs();
  const inputDate = dayjs(date);
  if (inputDate.isSame(now, 'day')) {
    return 'Today';
  } else if (inputDate.isSame(dayjs().subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  } else if (inputDate.isSame(now, 'week')) {
    return 'This Week';
  } else if (inputDate.isSame(now, 'month')) {
    return 'This Month';
  } else {
    return inputDate.format('MMMM D, YYYY');
  }
};

export const getNotificationDate = (date: Date) => {
  const dateTitle = notificationTitleDateFormat(date);
  const inputDate = dayjs(date);
  if (dateTitle === 'Today' || dateTitle === 'Yesterday') {
    return transformDateFormat(inputDate, 'hh:mm A');
  } else if (dateTitle === 'This Week') {
    return transformDateFormat(inputDate, 'hh:mm A, dddd');
  } else if (dateTitle === 'This Month') {
    return transformDateFormat(inputDate, 'hh:mm A, DD MMMM');
  } else {
    return transformDateFormat(inputDate, 'hh:mm A');
  }
};
